const plans = [
  {
    label: 'Launch for USD$ 20.00/month',
  },
  {
    label: 'Essential for USD$ 60.00/month',
    selected: true,
  },
  {
    label: 'Premium for USD$ 90.00/month',
  },
  {
    label: 'Enterprise (please contact Sales)',
    disabled: true,
  },
]

export default plans
